<template>
  <v-sheet class="idcs-main-list fluid">
    <v-row align="center" align-content="center" justify="center" class="ma-2">
      <v-card v-for="item in items" :key="item.idx" class="ma-2 yellow lighten-4" width="500">
        <v-card-title>
          <v-chip color="red" dark>{{item.idx}}</v-chip>
          <span class="ml-2 subtitle-2">{{item.uriPath}}</span>
          <v-spacer></v-spacer>
          <span class="mr-2">{{item.terminal}}</span>
          <span>{{item.domen}}</span>
        </v-card-title>
        <v-card-text>
          <v-row v-if="item.request">
            <v-col>
              <div>
                <span class="mr-4 subtitle-2">Request</span>
                <span>{{item.created |dt-time}}</span>
              </div>
              <span>{{JSON.stringify(item.request)}}</span>
            </v-col>
          </v-row>
          <v-row v-if="item.response">
            <v-col>
              <div>
                <span class="mr-4 subtitle-2">Response</span>
                <span v-if="item.response.date">{{item.response.date|dt-time}}</span>
              </div>
              <span>{{JSON.stringify(item.response)}}</span>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="accept(item)">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-row>
  </v-sheet>
</template>

<script>
export default {
  name: "Transactions",
  data() {
    return {
      items: [],
    };
  },
  methods: {
    loadData() {
      this.$api.getTransactions().then((r) => {
        this.items = r;
      });
    },
    accept(item) {
      this.$api.manualAcceptTransaction(item.idx).then((r) => {
        if (r == 1) {
          const i = this.items.indexOf(item);
          if (i != -1) this.items.splice(i, 1);
        }
      });
    },
  },
  mounted() {
    // if (!this.$store.getters["admin/isWebPosUsers"]) {
    //   this.$store.dispatch("admin/LOAD_WEBPOSUSERS");
    // }
    this.loadData();
  },
};
</script>

<style scoped>
.fluid {
  width: 100%;
  height: 100%;
}
</style>